import {switchLanguageWithMotion} from './language-motion.js?v=935cd45362cf';
let pending=false,nativeSubmission=false;
document.addEventListener('submit',async event=>{
 const form=event.target;if(form.id!=='LumaLanguage'||nativeSubmission)return;
 if(pending){event.preventDefault();return;}
 const button=event.submitter;if(!button?.value||button.value===document.documentElement.lang){event.preventDefault();return;}
 event.preventDefault();pending=true;
 const submit=()=>{try{sessionStorage.setItem('luma-language-arrival','1');}catch{}nativeSubmission=true;form.requestSubmit(button);};
 try{if(document.documentElement.dataset.languageMotionState==='running'){submit();return;}await switchLanguageWithMotion(submit,{navigation:true});}catch{if(!nativeSubmission)submit();}
});
try{if(sessionStorage.getItem('luma-language-arrival')==='1'){sessionStorage.removeItem('luma-language-arrival');switchLanguageWithMotion(()=>{},{arrival:true});}}catch{}

const hero=document.querySelector('main .hero'), routineShortcut=document.querySelector('.support');
if(hero&&routineShortcut&&'IntersectionObserver' in window){const visibility=new IntersectionObserver(entries=>{routineShortcut.hidden=entries[0].isIntersecting;});visibility.observe(hero);}
